module.exports = __webpack_public_path__ + "media/assets/images/nosco_panel-1a0b6aa5262c3969eb8c57e1bb4d3fe8.jpg";